export * from './src/portfolio-project-items-v1-project-item-project-items.meta.js';
